module.exports = __webpack_public_path__ + "img/bevill-state-logo.b3cb1f3b.jpg";